import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/drug-route";

export const pagingDrugRoute = (searchPayload) =>
  axios.post(`${API_PATH}/search-by-page`, searchPayload);

export const getDrugRouteById = (drugRouteId) =>
  axios.get(`${API_PATH}/get-by-id/${drugRouteId}`);

export const saveOrUpdateDrugRoute = (drugRoute) =>
  axios.post(`${API_PATH}/save-or-update`, drugRoute);

export const deleteDrugRoute = (drugRouteId) =>
  axios.delete(`${API_PATH}/mark-delete/${drugRouteId}`);

export const saveDrugRouteSyncStore = (result) => axios.post(API_PATH + "/sync-drug-route", result);
